export const CHALLENGE_SET_ENROLLMENT = "CHALLENGE_SET_ENROLLMENT";
export const CHALLENGE_SET_STATUS = "CHALLENGE_SET_STATUS";
export const CHALLENGE_ACTIVATE = "CHALLENGE_ACTIVATE";
export const CHALLENGE_APPLY_DAY_RESULT = "CHALLENGE_APPLY_DAY_RESULT";
export const CHALLENGE_SET_FINAL_ASSESSMENT_DONE = "CHALLENGE_SET_FINAL_ASSESSMENT_DONE";
export const CHALLENGE_RESET = "CHALLENGE_RESET";
export const CHALLENGE_SET_FROM_SERVER = "CHALLENGE_SET_FROM_SERVER";
